import { bool, object, func } from 'prop-types'
import { Select, kuiperClassNames } from '@opallabs/kuiper'
import { Tooltip } from '@opallabs/lapidary'

import './styles.scss'

const cardDisabledText =
  'Content card is only available when viewing mosaic or column layout'
const seamlessDisabledText =
  'Seamless is only available when sorting by content order'
const cardDisabledTooltip = {
  content: cardDisabledText,
  className: 'view-switcher-select',
  themeClass: 'white',
  popoverOptions: {
    constraints: [{ popover: 'left center', attachment: 'right center' }],
  },
}
const layoutDisabledTooltip = {
  content: seamlessDisabledText,
  className: 'view-switcher-select',
  themeClass: 'white',
  popoverOptions: {
    constraints: [{ popover: 'right center', attachment: 'left center' }],
  },
}

const selectOptions = (disabled) => ({
  layout: [
    { id: 1, title: 'Mosaic', removable: false, icon: 'view-mosaic' },
    { id: 2, title: 'Column', removable: false, icon: 'view-column' },
    {
      id: 3,
      title: 'Seamless',
      removable: false,
      icon: 'view-seamless',
      disabled,
      tooltip: disabled ? layoutDisabledTooltip : null,
    },
  ],
  chrome: [
    {
      id: 1,
      title: 'Content card',
      removable: false,
      icon: 'card',
      disabled,
      tooltip: disabled ? cardDisabledTooltip : false,
    },
    { id: 2, title: 'Content only', removable: false, icon: 'cardless' },
  ],
})

const ViewSwitcher = ({
  chromeValue,
  disableSeamless = false,
  layoutValue,
  onChromeChange,
  onLayoutChange,
}) => (
  <div className={kuiperClassNames('view-switcher')}>
    <Tooltip content={layoutValue.title} legacyTheme="dark" zIndex={9999}>
      <span>
        <Select
          className="view-switcher"
          value={layoutValue}
          theme="invisible"
          onChange={onLayoutChange}
          options={selectOptions(disableSeamless).layout}
        />
      </span>
    </Tooltip>
    <Tooltip content={chromeValue.title} legacyTheme="dark" zIndex={9999}>
      <span>
        <Select
          className="view-switcher"
          value={chromeValue}
          theme="invisible"
          onChange={onChromeChange}
          options={selectOptions(layoutValue.title === 'Seamless').chrome}
        />
      </span>
    </Tooltip>
  </div>
)

ViewSwitcher.propTypes = {
  chromeValue: object,
  disableSeamless: bool,
  layoutValue: object,
  onChromeChange: func,
  onLayoutChange: func,
}

export default ViewSwitcher
